import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NewVersionDialogComponent } from '../standalone/new-version-dialog/new-version-dialog.component';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
	private currentVersion: string = '';

	constructor(
		private http: HttpClient,
		private injector: Injector
	) {}

	initVersionCheck(intervalMs: number = 60000) {
		this.getMetaVersion().then((version) => (this.currentVersion = version));

		interval(intervalMs).subscribe(() => {
			try {
				this.getMetaVersion().then((serverVersion) => {
					if (!serverVersion) {
						console.warn('No version found in meta.json');
						return;
					}
					if (this.currentVersion && serverVersion !== this.currentVersion) {
						console.log('New version!');
						const dialog = this.injector.get(MatDialog);
						const isDialogOpen = dialog.getDialogById('version-update-dialog');
						if (!isDialogOpen) {
							dialog.open(NewVersionDialogComponent, {
								id: 'version-update-dialog',
								width: '400px',
								disableClose: true,
							});
						}
					}
				});
			} catch (error) {
				console.error('Error checking for new version:', error);
			}
		});
	}

	private async getMetaVersion(): Promise<string> {
		try {
			const data: any = await this.http.get('/assets/meta.json', { headers: { 'Cache-Control': 'no-cache' } }).toPromise();
			return data?.version;
		} catch (err) {
			console.warn('Error loading meta.json', err);
			return '';
		}
	}
}
